export const FEEDBACK_DELAY_MS = 200;
export const ASCII_LOWERCASE_A = 97;
export const MESSAGES = {
  CLIENT_LABEL: 'Cliente',
  NEXT_QUESTION: 'Próxima pergunta',
  FINISH_AND_VIEW_RESULTS: 'Finalizar e ver resultado',
} as const;
export const ANSWER_STATE_CLASSES = {
  CORRECT: 'is-correct',
  INCORRECT: 'is-incorrect',
  CORRECT_ANSWER: 'is-correct-answer',
  ACTIVE: 'is-active',
} as const;
